<template>
	<div class="ExpiryDashboard">
		<el-card class="box-card" style="overflow: visible;">
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :md="24" :lg="24" :xl="24">
					<div class="header-section">
						<div>
							<div style="color: #e29d5a; font-weight: 600;">
								Expiry
							</div>
						</div>
					</div>
				</el-col>
			</el-row>

			<div class="flex my-4">
				<div class="mb-4" style="margin-right: 60px; font-weight: 600;">
				 	<span :class="[projected_tab ? 'active' : 'tab']" @click="projected_tab = true">Projected Expiry</span>
				</div>
				<div class="mb-4" style="margin-right: 60px; font-weight: 600;">
					<span :class="[!projected_tab ? 'active' : 'tab']" @click="projected_tab = false">Items Expired</span>
				</div>
			</div>
			<el-row :gutter="20" class="my-3">
				<el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
					<div>
						<p class="input-label">Report</p>
						<el-select v-model="quickReportsSelected" :disabled="!projected_tab" style="width:100%; margin-top:5px;">
							<el-option
								v-for="(Quick, QuickIndex) in allQuickReports"
								:key="QuickIndex"
								:value="Quick.id"
								:label="Quick.name"
								class="capitalize"
							/>
						</el-select>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="10" :lg="10" :xl="10">
					<div>

						<p class="input-label">Select Store</p>
						<el-select
							v-model="location"
							style="width: 100%; margin-top: 5px;"
							filterable
							placeholder="Select Location"
							class="capitalize"
						>
							<el-option
								v-for="(outlet, outletIndex) in locations"
								:key="outletIndex"
								:value="outlet.id"
								:label="outlet.name"
								class="capitalize"
							/>
						</el-select>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
					<div>
						<p class="input-label">From</p>
						<el-date-picker
							v-model="date"
							value-format="yyyy-MM-dd"
							style="width: 100%; margin-top:5px;"
							type="date"
							placeholder="Select Date"
							:disabled="quickReportsSelected != 'wfr'"
						>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
					<div>
						<p class="input-label">To</p>
						<el-date-picker
							v-model="toDate"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Select Date"
							style="width: 100%; margin-top:5px;"
							:disabled="quickReportsSelected != 'wfr'"
						/>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="2" :lg="2" :xl="2">
					<label>&nbsp;</label>
					<BaseButton
						type="text"
						style="height: 40px; margin-top:5px;"
						class="orng-btn"
						buttonclass="btn p-2 text-sm font-extrabold"
						@click="goToEvents"
						>Go</BaseButton
					>
				</el-col>
			</el-row>
			<div>
				<el-row :gutter="20">
					<el-col :xs="12" :sm="12" :md="10" :lg="10" :xl="10">
						<base-categories-dropdown
							v-if="projected_tab"
							class="mdms"
							style="width: 100%"
							@categoryUpdate="categoryDropDownUpdate"
						/>
					</el-col>
				</el-row>
			</div>
			<!-- <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" class="mt-4">
					<p class="input-label">Notification Type</p>
					<el-select
						v-model="notification_type"
						multiple
						collapse-tags
						placeholder="Select"
						style="width: 100%; margin-top: 5px;"
					>
						<el-option label="Notification" value="notification"></el-option>
					</el-select>
				</el-col> -->
			<!-- </el-row> -->
		</el-card>

		<el-card class="box-card mt-5">
			<!-- <div
				class="text-sm font-semibold"
				style="display: flex; justify-content: flex-end; color: #e29d5a;"
			>
				Export to .csv
			</div> -->
			<div v-if="projected_tab" class="tableHeight">
				<simplebar class="simplebar">
					<table v-if="projected_tab" class="tableMain">
						<thead>
							<tr>
								<th>

								</th>
								<th>
									Item Description
								</th>
								<th>
									batch No
								</th>
								<th>
									Shelf life
								</th>
								<th>
									Current Usage
								</th>
								<th>
									Current Stock
								</th>
								<th>
									Days Remaining
								</th>
								<th>
									Projected Expiry
								</th>
								<th>
									Stock value
								</th>
								<th>
									&nbsp;
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in stockCalendar" :key="index">
								<td v-if="projected_tab">
									<input v-model="item.checked" type="checkbox">
								</td>
								<td class="">
									<p class="py-1 font-bold capitalize">{{ item.item_name }}</p>
									<p class="py-1">{{ item.item_code }}</p>
									{{ item.current_stock }} {{ item.order_unit }} x
									{{ item.unit_conversion }} {{ item.base_unit }}
								</td>
								<td>
									{{ item.batch_code }}
								</td>
								<td>
									{{ item.item_shelf_life }}
								</td>
								<td>
									{{ item.usage }}
								</td>
								<td>
									{{ item.current_stock * item.unit_conversion }}
									{{ item.base_unit }}
								</td>
								<td>
									{{ item.days_remaining }}
								</td>
								<td>
									<p class="py-1">
										<b>QTY:</b> {{ item.stock_remaining }} {{ item.base_unit }}
									</p>
									<p class="py-1"><b>DATE:</b> {{ item.expiry_date }}</p>
								</td>
								<td>
									{{ (item.stock_remaining * item.unit_cost).toFixed(2) }}
								</td>
							</tr>
						</tbody>
					</table>

					<!-- <div class="footer-section">
						<BaseButton
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="saveStockCalendarSchedule()"
						>
							Save
						</BaseButton>
					</div> -->
				</simplebar>
			</div>
			<table v-if="!projected_tab" class="tableMain">
						<thead>
							<tr>
								<th style="max-width: 100px; text-align: left;">
									Batch
								</th>
								<th style="width: 250px;text-align: left;">
									Item Name
								</th>
								<th>
									Quantity Expired
								</th>
								<!-- <th colspan="2">
									<p class="main-heading-border-bottom">Actual Count</p>
								</th>
								<th colspan="2">
									<p class="main-heading-border-bottom">Variance</p>
								</th> -->
								<!-- <th>
									<div class="heading-bottom-margin">
										Reason
									</div>
								</th> -->
								<th>
									<div class="heading-bottom-margin">
										Expiry Date
									</div>
								</th>
							</tr>
							<!-- <tr>
								<th style="width: 100px;">&nbsp;</th>
								<th style="width: 250px;">&nbsp;</th>
								<th style="width: 100px;">Pack Qty</th>
								<th style="width: 100px;">Loose Qty</th>
								<th style="width: 120px;">Pack Qty</th>
								<th style="width: 120px;">Loose Qty</th>
								<th style="width: 100px;">Pack Qty</th>
								<th style="width: 100px;">Loose Qty</th>
								<th style="width: 150px;">&nbsp;</th>
							</tr> -->
						</thead>
						<tbody
							v-for="(stock, stockCountIndex) in expiry_data"
							:key="stockCountIndex"
						>
							<tr style="padding: 5px 0;">
								<td style="width: 100px;text-align: left; text-transform: capitalize;">
									{{ stock.code }}
								</td>
								<td
									style="width: 250px; text-align: left; text-transform: capitalize;"
									class="font-semibold"
								>
									{{ stock.article_info.name }}
								</td>
								<td style="width: 100px;">
									{{ stock.quantity }}
								</td>
								<!-- <td style="width: 100px;">
									{{ stock.loose_quantity }} {{ stock.base_unit }}
								</td>
								<td style="width: 200px;" class="number-input">
									{{stock.loose_quantity}}
								</td>
								<td style="width: 200px;" class="number-input">
									{{stock.quantity}}
								</td>
								<td style="width: 100px;">
									{{stock.quantity}}
								</td>
								<td style="width: 100px;">
									<div
										style="display: flex; align-items: center; justify-content: center;"
									>
										{{stock.loose_quantity}}

									</div>
								</td> -->
								<td
									style="width: 150px;"
									:style="{
										color:
											new Date() >
											new Date(stock.expiry_date).setHours(0, 0, 0, 0)
												? '#d60918'
												: '#000'
									}"
								>
									{{ new Date(stock.expiry_date).toLocaleDateString() }}
								</td>
								<!-- <td colspan="10" style="padding: 0;">
									<table style="width: 100%; margin: 0; border: none;">
										<tbody
											v-for="(stock, stockCountIndex) in stockCount"
											:key="stockCountIndex"
										>
											<tr>
											</tr>
										</tbody>

									</table>
								</td> -->
							</tr>
						</tbody>
					</table>
				<div class="text-right mt-4">
					<div
						v-if="stockCalendar.length"
						class="pagination p-4 pt-0 text-right"
					>
						<el-pagination
							background
							:current-page.sync="pageInfo.currentPage"
							layout="prev, pager, next"
							:total="pageInfo.count"
							@current-change="handlePageInfoChange"
						/>
					</div>
				</div>
			<div
					v-if="projected_tab"
					style="display: flex; justify-content: flex-end; margin-top: 10px;"
				>
					<BaseButton
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="goToCampaing"
					>
						LIQUIDATE
					</BaseButton>
				</div>
		</el-card>

		<!-- <el-card class="box-card mt-5">
			<el-row>
				<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
					<p class="input-label">Recipients</p>
					<el-select
						v-model="recipients"
						placeholder="Select"
						multiple
						style="width: 100%;"
					>
						<el-option label="Manish" value="Manish"></el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-row :gutter="30" class="mt-5">
				<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<table class="tableMain">
						<thead>
							<tr>
								<th>Name</th>
								<th>Designation</th>
								<th>Email Id</th>
								<th>Mobile No</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Manish Thakur</td>
								<td>-</td>
								<td>manish@nymbleup.com</td>
								<td>9876543210</td>
							</tr>
						</tbody>
					</table>
				</el-col>
			</el-row>
		</el-card> -->
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import ExpiryService from "../../../../services/expiryService";
import CommonService from "../../../../services/commonService";
import { Promise } from "q";
import { CommonMixin } from "../../../../../mixins/common.mixin";
import { resolve } from "q";
import moment from "moment";
import { EventBus } from "../../../../eventBus";
import BaseCategoriesDropdown from "../../../baseCategoriesDD/BaseCategoriesDD.vue";
export default {
	name: "ExpiryDashboard",
	components: {
		simplebar,
		BaseCategoriesDropdown
	},
	mixins: [CommonMixin],
	data() {
		return {
			projected_tab: true,
			date: "",
			toDate: "",
			isCategoryPage: "",
			quickReportsSelected: "wfr",
			weeklyDropdownList: [
				{
					label: "Monday",
					value: "1"
				},
				{
					label: "Tuesday",
					value: "2"
				},
				{
					label: "Wednesday",
					value: "3"
				},
				{
					label: "Thursday",
					value: "4"
				},
				{
					label: "Friday",
					value: "5"
				},
				{
					label: "Saturday",
					value: "6"
				},
				{
					label: "Sunday",
					value: "7"
				}
			],
			allQuickReports: [
				{
					name: "Week To Date",
					id: "wtd",
					isDisabled: false,
				},
				{
					name: "Month To Date",
					id: "mtd",
					isDisabled: false,
				},
				{
					name: "Year To Date",
					id: "ytd",
				},
				{
					name: "Custom Dates",
					id: "wfr",
				}
			],
			monthlyDropdownList: [
				{
					label: "Start of the Month",
					value: "start_of_the_month"
				},
				{
					label: "15th of the Month",
					value: "15th_of_the_month"
				},
				{
					label: "End of the Month",
					value: "end_of_the_month"
				}
			],
			expiry_data: [],
			stockCalendar: [],
			expiry_alert_list: [],
			categories: [],
			outletId: "",
			pageInfo: {
				currentPage: 1,
				count: 0,
				pageSize: 10,
				search: ""
			},
			filters: {
				categories: [],
				departments: [],
				subcategories: [],
				products: [],
			},
			locations: [],
			location: "",
			recipients: "",
			notification_type: "",
			userDetails: {}
		};
	},
	created() {
		// this.getStockCountSchedule();

		this.getLocations().then(locations => {
			this.locations = locations;
			// this.location = this.locations[0].id;
			if (this.location) {
				// this.getStockByLocation();
			}
		});
		this.getUserSelf().then(userDetails => {
			this.userDetails = userDetails;
		});
		this.date = moment(new Date()).format("YYYY-MM-DD");
		this.toDate = moment(new Date()).format("YYYY-MM-DD");
	},
	methods: {
		goToCampaing(){
			localStorage.setItem("checklist", [])
			let obj = {
				checklist: []
			}
			for(let i = 0; i < this.stockCalendar.length; i++){
				if(this.stockCalendar[i].checked == true) {
					obj.checklist.push(this.stockCalendar[i].article_id);
				}
			}
			if(obj.checklist.length) {
				obj.checklist = [...new Set(obj.checklist)];
				localStorage.setItem("checklist", JSON.stringify(obj));
				this.$router.push({path: `/admin/create-campaign/${this.location}`}).catch(()=>{});
			}
		},
		checkItem(index, check) {
			this.stockCalendar[index].checked != this.stockCalendar[index].checked;
		},
		categoryDropDownUpdate(categoryDDUpdate){
			console.log("categoryDDUpdate", categoryDDUpdate);
			this.filters = {
				outlets: [this.location],
				categories: [],
				departments: [],
				subcategories: [],
				products: [],
			};
			let id = categoryDDUpdate.cat_selected.map(e => {
				return e.id;
			});
			// this.handleResetPageInfoEvent();
			if(categoryDDUpdate.cat_basics == "department") {
				this.filters.departments = id;
			} else if (categoryDDUpdate.cat_basics == "category") {
				this.filters.categories = id;
			}else if (categoryDDUpdate.cat_basics == "subcategory") {
				this.filters.subcategories = id;
			}else if (categoryDDUpdate.cat_basics == "product") {
				this.filters.products = id;
			}
		},
		changedReport(){
			var date = new Date();
			// if (this.quickReportsSelected == "wtd") {
			// 	let first = date.getDate() - date.getDay();
			// 	let firstDay = new Date(date.setDate(first + 1)).toUTCString();
			// 	this.date = moment(firstDay).format("YYYY-MM-DD");
			// 	} else if (this.quickReportsSelected == "mtd") {
			// 	let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			// 	this.date = moment(firstDay).format("YYYY-MM-DD");
			// 	// var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			// 	} else if (this.quickReportsSelected == "ytd") {
			// 	let firstDay = new Date(this.getCurrentFinancialYear(), 3, 1);
			// 	this.date = moment(firstDay).format("YYYY-MM-DD");
			// }
		},
		getCurrentFinancialYear() {
			var financial_year = "";
			var today = new Date();
			if (today.getMonth() + 1 <= 3) {
				financial_year = today.getFullYear() - 1;
			} else {
				financial_year = today.getFullYear();
			}
			return financial_year;
		},
		changedStore() {
			this.pageInfo = {
				currentPage: 1,
				count: 0,
				pageSize: 10,
			};
			this.getExpiryData();
		},
		handleResetPageInfoEvent() {
			this.pageInfo = {
				currentPage: 1,
				count: 0,
				pageSize: 10,
			};
		},
		handlePageInfoChange(val) {
			this.pageInfo.currentPage = val;
			this.getExpiryData();
		},
		goToEvents() {
			if(this.projected_tab){
				this.getExpiryData();
			} else {
				this.getExpiredData();
			}
		},
		getExpiredData(){
			let params = {
				outlet: this.location,
				from_date: this.date,
				to_date: this.toDate,
			};
			ExpiryService.getExpiredData(params, this.pageInfo)
				.then(res => {
					console.log(JSON.parse(res.data));
					this.expiry_data = JSON.parse(res.data).results;
					this.pageInfo.count = JSON.parse(res.data).count;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getExpiryData() {
			this.location ? this.filters.outlets = this.location ?  [this.location] : [] : '';
			let params = {
				filters: this.filters,
				from_date: this.date,
				to_date: this.toDate,
				quick_report: this.quickReportsSelected
			};
			ExpiryService.getExpiry(params, this.pageInfo)
				.then(res => {
					console.log(JSON.parse(res.data));
					this.stockCalendar = JSON.parse(res.data).results;
					this.pageInfo.count = JSON.parse(res.data).count;
					if(JSON.parse(res.data).results.length) {
						for(let i = 0; i < this.stockCalendar.length; i++){
							this.stockCalendar[i].checked = false;
						}
					}
					console.log(this.stockCalendar);
				})
				.catch(err => {
					console.log(err);
				});
		},
		// getStockByLocation() {
		// 	InventoryService.viewStockCountSchedule({
		// 		outlet_id: this.location
		// 	})
		// 		.then(data => {
		// 			this.stockCalendar = data.results;
		// 			for (var i = 0; i < this.stockCalendar.length; i++) {
		// 				this.$set(this.stockCalendar[i], "weekly", []);
		// 				this.$set(this.stockCalendar[i], "monthly", []);
		// 				if (this.stockCalendar[i].frequency === "monthly") {
		// 					console.log(this.stockCalendar[i].frequency);
		// 					this.stockCalendar[i].monthly = [
		// 						...this.stockCalendar[i].days
		// 					].toString();
		// 				}
		// 				if (this.stockCalendar[i].frequency === "weekly") {
		// 					console.log(this.stockCalendar[i].frequency);
		// 					this.stockCalendar[i].weekly = [
		// 						...this.stockCalendar[i].days
		// 					].toString();
		// 				}
		// 			}
		// 			this.pageInfo.totalCount = data.count;
		// 		})
		// 		.catch(err => {
		// 			let message;
		// 			console.log(err);
		// 			if (err === "no access_outlet") {
		// 				message = "Please set outlet in user permissions";
		// 			} else {
		// 				message = "Something went wrong!";
		// 			}
		// 			this.$notify.error({
		// 				title: "Fail",
		// 				message: message,
		// 				duration: 0
		// 			});
		// 		});
		// },
		// changeFrequType(frequency, index) {
		// 	console.log(this.stockCalendar[index].days);
		// 	if (frequency === "daily") {
		// 		this.stockCalendar[index].monthly = "";
		// 		this.stockCalendar[index].weekly = "";
		// 	}
		// 	if (frequency === "monthly") {
		// 		this.stockCalendar[index].monthly = [
		// 			...this.stockCalendar[index].days
		// 		].toString();
		// 		this.stockCalendar[index].weekly = "";
		// 	}
		// 	if (frequency === "weekly") {
		// 		this.stockCalendar[index].weekly = [
		// 			...this.stockCalendar[index].days
		// 		].toString();
		// 		this.stockCalendar[index].monthly = "";
		// 	}
		// },
		paginate() {
			return pageInfo => {
				InventoryService.viewStockCountSchedule({
					outlet_id: this.outletId,
					pageInfo
				}).then(data => {
					this.stockCalendar = data.results;
					this.pageInfo.totalCount = data.count;
				});
			};
		},
		async getUserSelf() {
			try {
				var userDetails = await CommonService.getLoggedinUserData().then(data =>
					resolve(data)
				);
			} catch (err) {
				console.log(err);
			}
			return userDetails;
		},
		async getLocations() {
			try {
				var locations = await CommonService.getOutlets({ get_all: true }).then(
					response => {
						return JSON.parse(response.data);
					}
				);
			} catch (err) {
				console.log(err);
			}
			return locations;
		},
		saveStockCalendarSchedule(frequency, { index = null } = {}) {
			// if (index) {
			// 	if (frequency === "weekly") {
			// 		this.stockCalendar[index].days = [this.stockCalendar[index].weekly];
			// 	} else if (frequency === "monthly") {
			// 		this.stockCalendar[index].days = [this.stockCalendar[index].monthly];
			// 	} else if (frequency === "daily") {
			// 		this.stockCalendar[index].days = [0];
			// 	}
			// }
			// for (var i = 0; i < this.stockCalendar.length; i++) {
			// 	if (this.stockCalendar[i].frequency === "monthly") {
			// 		this.stockCalendar[i].days = [Number(this.stockCalendar[i].monthly)];
			// 	} else if (this.stockCalendar[i].frequency === "weekly") {
			// 		this.stockCalendar[i].days = [Number(this.stockCalendar[i].weekly)];
			// 	} else {
			// 		this.stockCalendar[i].days = [0];
			// 	}
			// }
			// InventoryService.saveStockCountSchedule({
			// 	outlet_id: this.location,
			// 	params: index ? [this.stockCalendar[index]] : this.stockCalendar
			// })
			// 	.then(response => {
			// 		if (response.status === 201) {
			// 			this.$notify.success({
			// 				title: "Success",
			// 				message: JSON.parse(response.data).message
			// 			});
			// 		} else {
			// 			Promise.reject("error");
			// 		}
			// 	})
			// 	.catch(err => {
			// 		console.log(err);
			// 		this.$notify.error({
			// 			title: "Fail",
			// 			message: "Something Went Wrong"
			// 		});
			// 	});
		}
		// getStockCountSchedule() {
		// 	CommonService.getLoggedinUserData()
		// 		.then(data => {
		// 			if (data) {
		// 				this.outletId = data.access_outlet;
		// 				return data;
		// 			} else {
		// 				return Promise.reject("no access_outlet");
		// 			}
		// 		})
		// 		.then(accesOutlet => {
		// 			if (accesOutlet.access_outlet) {
		// 				InventoryService.viewStockCountSchedule({
		// 					outlet_id: accesOutlet.access_outlet
		// 				}).then(data => {
		// 					this.stockCalendar = data.results;
		// 					this.pageInfo.totalCount = data.count;
		// 				});
		// 			}
		// 		})
		// 		.catch(err => {
		// 			let message;
		// 			console.log(err);

		// 			if (err === "no access_outlet") {
		// 				message = "Please set outlet in user permissions";
		// 			} else {
		// 				message = "Something went wrong!";
		// 			}
		// 			this.$notify.error({
		// 				title: "Fail",
		// 				message: message,
		// 				duration: 0
		// 			});
		// 		});
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "./ExpiryDashboard.scss";
</style>

<style lang="scss">
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
.AppLayout .el-select .el-input__inner {
	text-transform: capitalize;
}
</style>
